export const rootOrders = "orders";
export const getByUserId = "orders/getByUserId";
export const getAllNotesByOrder = "orders/notes/all";
export const postUpdateNote = "orders/notes/update";
export const postCreateNote = "orders/notes/create";
export const postDeleteNote = "orders/notes/delete";
